import { StaticRouter } from 'react-router';
import {
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_FAILURE,
    POST_USERS_SUCCESS,
    ADD_PREVIEW_USERS,
    REMOVE_PREVIEW_USERS,
    GET_USER_ROLES_REQUEST,
    GET_USER_ROLES_SUCCESS,
    GET_USER_ROLES_FAILURE
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    isUpdateFileLoaded: false,
    isNewFileLoaded: false,
    users: [],
    userRoles: [],
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_USER_ROLES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_USER_ROLES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                userRoles: action.payload.roles,
                isInitialFetch: false,
            };
        case GET_USER_ROLES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case GET_USERS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_USERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                users: action.payload.users,
                isInitialFetch: false,
                isNewFileLoaded: false,
                isUpdateFileLoaded: false
            };
        case GET_USERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case ADD_PREVIEW_USERS: {
            const newUsers = action.payload.users.map((u) => ({
                ...u,
                active: u.active === "1" || u.active === true,
                isDisabled: true,
            }));
            const usersToUpdateCount = newUsers.filter(i => (i.oldLoginName) ? true : false).length;
            let updatedUsers = [...state.users];
            if (usersToUpdateCount > 0) {
                updatedUsers = state.users.map(u => ({
                    ...u,
                    isHighlighted: newUsers.filter(i => i.oldLoginName === u.loginName).length > 0,
                    loginName: newUsers.filter(i => i.oldLoginName === u.loginName)[0]?.loginName || u.loginName,
                    oldLoginName: newUsers.filter(i => i.oldLoginName === u.loginName)[0]?.oldLoginName || u.oldLoginName,
                }));
            }
            return {
                ...state,
                users: usersToUpdateCount > 0
                    ? [...updatedUsers]
                    : [...newUsers, ...state.users],
                isNewFileLoaded: !usersToUpdateCount && newUsers.length > 0,
                isUpdateFileLoaded: usersToUpdateCount > 0,
            };
        };
        case REMOVE_PREVIEW_USERS: {
            const restoredUsers = state.users.map((u) => ({
                ...u,
                isHighlighted: false,
                loginName: u.oldLoginName || u.loginName,
                oldLoginName: null
            }));
            return {
                ...state,
                users: [...restoredUsers.filter((f) => !f.isDisabled)],
                isNewFileLoaded: false,
                isUpdateFileLoaded: false,
            };
        }
        case POST_USERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                users: action.payload.users,
                isInitialFetch: false,
                isNewFileLoaded: false,
                isUpdateFileLoaded: false,
            };
        default:
            return state;
    }
};